import { useCallback } from 'react'
import { useMutation } from '@apollo/client/react'

import {
  AdminAPI,
  getFragment,
  GraphQL,
  SharedAPI,
  utils
} from '@guestgoodie/graphql'

export function useDeletePromotion(
  promotionId?: number,
  onDone?: (
    promotion?: GraphQL.PromotionFragmentFragment,
    deleted?: boolean
  ) => void
) {
  const [deletePromotion] = useMutation(AdminAPI.promotion.DELETE, {
    update(cache, { data }) {
      if (!data) return

      const promotion = getFragment(
        SharedAPI.promotion.PROMOTION_FRAGMENT,
        data.deletePromotion
      )

      utils.paginationHelpers.remove(
        cache,
        promotion.id,
        'Promotion',
        'queryPromotions'
      )

      const normalizedId = cache.identify(data.deletePromotion)

      cache.modify<GraphQL.GetAllPromotionsForGoodieQuery>({
        id: 'ROOT_QUERY',
        fields: {
          getAllPromotionsForGoodie(goodies = [], { toReference }) {
            return goodies?.filter(
              goodieRef => toReference(goodieRef)?.__ref !== normalizedId
            )
          }
        }
      })

      cache.evict({ id: normalizedId })
      cache.gc()
    }
  })

  return useCallback(() => {
    if (!promotionId) return

    deletePromotion({ variables: { id: promotionId } })
    onDone?.(undefined, true)
  }, [promotionId, onDone, deletePromotion])
}
